export const AppInfo = {
  id: 'tomo',
  version: '1.1.4',
  name: 'Tomo Wallet',
  homepage: 'https://tomo.inc',
  logo: '',
  description: 'Multi-Chain Wallet based on Telegram, by tomo team 🧑‍🤝‍🧑',
  downloadLinks: {
    android: '',
    googlePlay: '',
    ios: '',
    appleStore: '',
    testflight: '',
    telegram: '',
    browserExtension: {
      chrome: '',
      edge: '',
    },
  },
  deepLinks: {
    scheme: 'tomo://',
    universallink: 'https://',
    direct_link: 'https://t.me/tomowalletbot/tomo_wallet',
  },
};

// Prod
export const BASE_URL = {
  bridge: 'https://bridge.anyconn.org/v1/sub',
  connect: 'https://tg.tomo.inc/bot-server/sdk/signature',
  connect_direct_link: 'https://t.me/tomowalletbot/tomo_wallet',
};

export const LOCALES = [
  'en_US',
  'ru_RU',
  'zh_CN',
  'zh',
  'ar_AE',
  'cs_CZ',
  'de_DE',
  'es_ES',
  'es_LAT',
  'fr_FR',
  'id_ID',
  'it_IT',
  'nl_NL',
  'pl_PL',
  'pt_BR',
  'pt_PT',
  'ro_RO',
  'tr_TR',
  'uk_UA',
  'vi_VN',
];

export const supportedEvmChainIdDefault = [
  1,
  56,
  42161,
  10,
  8453,
  59144,
  81457,
  137,
  43114,
  5003,
  11155111,
  11155420,
  331239,
  534352,
  8333,
  324,
  202105,
  5545,
  47763,
  686868,
  4200,
  2649,
  2648,
  200901,
  200810,
  1513,
  80084,
  3636,
  480,
];
